import { render } from "./TabsManager.vue?vue&type=template&id=3b000a2e&scoped=true"
import script from "./TabsManager.vue?vue&type=script&lang=js"
export * from "./TabsManager.vue?vue&type=script&lang=js"

import "./TabsManager.vue?vue&type=style&index=0&id=3b000a2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b000a2e"

export default script